import { render, staticRenderFns } from "./CeldaArchivo.vue?vue&type=template&id=b43323be&scoped=true&"
import script from "./CeldaArchivo.vue?vue&type=script&lang=js&"
export * from "./CeldaArchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43323be",
  null
  
)

export default component.exports